var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guideContainer trackCanv",style:({ width: (_vm.width + "px") })},_vm._l((_vm.guides),function(ref,index){
var startTime = ref.startTime;
var endTime = ref.endTime;
return _c('div',{key:("guide-" + index),staticClass:"guide",style:({
			left: ((100 * _vm.convertSecondsToProportion(startTime, _vm.offset, _vm.zoom)) + "%"),
			width: (((100 * (endTime - startTime) * _vm.basePxPerSec * _vm.zoom) / _vm.width) + "%"),
		})})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }